<section class="modal modal--{{modalData.type}} {{modalData.modalType}}">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <div class="flex-always">
          <img width="20" src="../../../../../images/cross.svg" alt="cross icon">
          <p class="modal-title">{{modalData.title}}</p>
        </div>
      </div>
      <div class="modal-body">
        <p class="">{{modalData.content}}</p>
        <button (click)="selectTimeSlotHandler()">{{modalData.buttonText}}</button>
      </div>
    </div>
  </div>
</section>
